export default {
  "checkOrder.checkPopupBox": "Check the popup box",
  "checkOrder.checkOrderUploads": "check order uploads",
  "checkOrder.checkExpired":
    "The following order check results have expired. Please click [Initiate Check] to check before placing a flyer.",
  "checkOrder.CheckItems": "Check items",
  "checkOrder.checkResultLevel": "Check result level",
  "checkOrder.lauchInspection": "lauch inspection",
  "checkOrder.exportResults": "Export results",
  "checkOrder.open": "Yes",
  "checkOrder.close": "No",
  "checkOrder.uploadOrder": "upload order",
  "checkOrder.checkResultDetails": "Check result details",
  "checkOrder.checkResult": "check result",
  "checkOrder.pass": "pass",
  "checkOrder.abnormal": "abnormal",
  "checkOrder.warn": "warn",
  "checkOrder.hint": "hint",
  "checkOrder.form": "form",
  "checkOrder.product": "product",
  "checkOrder.orderNumber": "order number",
  "checkOrder.mainContractNumber": "main contract number",
  "checkOrder.brandCategory": "Brand category",
  "checkOrder.productChannels": "Product channels",
  "checkOrder.standardProducts": "Standard products",
  "checkOrder.placeOrders": "Place orders",
  "checkOrder.placeOrders2": "Go and place an order",
  "checkOrder.specification": "Specification",
  "checkOrder.code": "code",
  "checkOrder.model": "model",
  "checkOrder.classification": "Classification",
  "checkOrder.details": "Details",
  "checkOrder.fold": "Fold",
  "checkOrder.unfold": "Collapse",
  "checkOrder.foldUnfold": "Expand/ Collapse",
  "checkOrder.orderParameters": "Order parameters",
  "checkOrder.instruction": "instruction",
  "checkOrder.beingChecked":
    "The initiated inspection task is being checked, please wait...",
  "checkOrder.confirm": "confirm",
  "checkOrder.closeModify": "Close order to modify",
  "checkOrder.checkCompleted": "Check completed",
  "checkOrder.checkFailed": "Check failed",
  "checkOrder.checkTotal":
    "A total of X design objects are checked, including X exceptions, X warnings, X hints",
  "checkOrder.checkTotal1": "A total of ",
  "checkOrder.checkTotal2": "design objects are checked, ",
  "checkOrder.checkTotal3": "including",
  "checkOrder.checkTotal4": "exceptions",
  "checkOrder.checkTotal5": "warnings",
  "checkOrder.checkTotal6": "hints",
  "checkOrder.craftsmanship":
    "Please check the above craftsmanship issues carefully. If there is any quality problem, it will be used as the basis for the sale of the service, and the designer will be responsible for it.",
  "checkOrder.checkPage": "One-click order page check results",
  "checkOrder.checkInformation": "Check information",
  "checkOrder.abnormalOrders": "Abnormal orders",
  "checkOrder.warningOrder": "warning order",
  "checkOrder.hintingOrder": "hinting order",
  "checkOrder.all": "all",
  "checkOrder.source": "source",
  "checkOrder.details": "Details",
  "checkOrder.checkDetails": "Check details",
  "checkOrder.xItems1": "....about ",
  "checkOrder.xItems2": " items in total.",
  "checkOrder.failureInformation": "View failure information",
  "checkOrder.detectedCheck":
    'The system has detected that the order you have selected needs to undergo a unified check before placing an order. Please click the "Initiate inspection" button below, check and pass it, and then place the order again',
  "checkOrder.inspectionItems": "Select inspection items",
  "checkOrder.noInspectionItems":
    "There are currently no inspection items available",
  "checkOrder.viewInspectionRecords": "View inspection records",
  "checkOrder.readingScene": "Reading scene file content",

  "checkOrder.checking": "Checking",
  "checkOrder.underInspection": "Under inspection",
  "checkOrder.inspectionRecords":
    "Please wait for the inspection results. You can manually refresh and view the inspection records",
  "checkOrder.inspectionRecords1":
    "Please wait for the inspection results. You can manually ",
  "checkOrder.inspectionRecords2": "refresh",
  "checkOrder.inspectionRecords3": "and view the inspection records",
  "checkOrder.clickRetry": "Click retry to initiate the check again",
  "checkOrder.clickRetry1": "Click ",
  "checkOrder.clickRetry2": "retry",
  "checkOrder.clickRetry3": "to initiate the check again",
  "checkOrder.batchID": "Check batch ID",
  "checkOrder.filledForms": "Number of forms need to be filled out:",
  "checkOrder.clickLocate": "Click to locate the problem module",
  "checkOrder.noDataAvailable": "There is currently no data available",
  "checkOrder.initiatingCheck": "Initiating check, please wait",
  "checkOrder.failedInspection":
    "Split order completed, failed to initiate inspection",
  "checkOrder.clickSeconds1": "Click in ",
  "checkOrder.clickSeconds2": "seconds",
  "checkOrder.mandatory": "Mandatory ",
  "checkOrder.checkTheBox": "Please check the box I am aware of",
  "checkOrder.checkTakes1": "The current check takes",
  "checkOrder.checkTakes2": "seconds",
  "checkOrder.pleaseWait": "Checking, please wait a moment",
  "checkOrder.newInspection":
    " The inspection result has expired or the order content has changed. Please initiate a new inspection",
  "checkOrder.confirmationForm": "Material Production Base Confirmation Form",
  "checkOrder.clickToFill": "Click to fill in",
  "checkOrder.submitted": "Submitted",
  "checkOrder.unsubmitted": "Unsubmitted",
  "checkOrder.canOrder":
    "Please initiate an inspection and wait for it to be completed. Only when there are no abnormalities can the order be placed",
  "checkOrder.pleaseRecheck":
    "Inspection failed, please recheck and place your order after completion",
  "checkOrder.beforeSendingFlyer":
    "There are abnormalities in the inspection results. Please modify them before sending the flyer",
  "checkOrder.fillFormFirst":
    "The form has not been submitted, please fill out the form first",
  "checkOrder.riskAwareness":
    "There is a warning in the inspection result. Please check the risk awareness before sending out the flyer",
  "checkOrder.beforeExporting":
    "Please initiate a check and wait for the check to complete before exporting the results",
  "checkOrder.selectChecked": "Select the products to be checked",
  "checkOrder.selectInspectionItem": "Please select the inspection item",
  "checkOrder.collapseResult": "Collapse result",
  "checkOrder.viewResults": "View Results",
  "checkOrder.initiateNewInspection": "Please initiate a new inspection",
  "checkOrder.abnormalitiesCantOrder":
    "Products with abnormalities cannot be ordered. Please click on [View Results] and follow the instructions to modify the abnormalities before placing an order",
  "checkOrder.confirmBeforePlacing ":
    "Please check the reminder and confirm before placing an order",
  "checkOrder.notCloseDesign1":
    "Please do not close the design proposal file for the current order while disassembling the design software. Please wait, it has taken",
  "checkOrder.notCloseDesign2": "seconds",
  "checkOrder.softwareCheck1":
    "The design software is undergoing a process check, please wait. It has currently taken",
  "checkOrder.softwareCheck2": "seconds",
  "checkOrder.checkTime": "Current check time X seconds",
  "checkOrder.meetTheInspection":
    "The selected product does not meet the inspection criteria. Please check if all selected products are bound and select inspection items",
  "checkOrder.haveBeenInformed":
    "I have been informed that orders cannot be placed when there are abnormalities in the inspection results. Orders can be placed when there are warnings, but there may be a risk of cancellation. To close the current prompt page, please check the box and click OK",
  "checkOrder.customizedProducts": "Customized products",
  "checkOrder.carefullyReview":
    "Please carefully review and verify the above process issues. Any quality or other issues will be used as a basis for sales and borne by the designer.",
  "checkOrder.inspectionExport":
    "Process inspection results do not support export",
  "checkOrder.checkRisk": "Please check the box for risk awareness",
  "checkOrder.followingSituations":
    "Please check the following situations before placing an order: <p>1. If there are any abnormalities in the inspection results, please modify the abnormalities before placing an order; </p><p>2. If there is a warning, please read and check the risk awareness before placing an order;</p>",
  "checkOrder.inspectionProgress":
    "Inspection in progress, please wait a moment",
  "checkOrder.refreshInspection":
    "Please refresh the inspection results. If the inspection fails, it needs to be rechecked",
  "checkOrder.unableCheck":
    "Split order not completed, inspection batch not generated, unable to check",
  "checkOrder.refreshButton": "Please click and refresh order progress button",
  "checkOrder.obtainedBatchID":
    "We have not yet obtained the inspection batch ID, please try again",
  "checkOrder.inspectionIncomplete":
    "Inspection incomplete/failed, unable to place order",
  "checkOrder.itemsApply": "The above check items apply to all",
  "checkOrder.channelProducts": "channel products",
  "checkOrder.cancel": "cancel",
  "checkOrder.orderFirst": "Please select a service order first",
  "checkOrder.selectProductCategory": "Please select a product category",

  "checkOrder.orderCategory": "Order category",
  "checkOrder.designer": "Designer",
  "checkOrder.designerPhone": "Designer phone",
  "checkOrder.draftsman": "Draftsman",
  "checkOrder.draftsmanPhone": "Draftsman's phone",
  "checkOrder.expectedDeliveryTime": "Expected delivery time",
  "checkOrder.createStandards": "Create standards separately",
  "checkOrder.myOrderTask": "My order task",
  "checkOrder.customerInfo": "Customer Info",
  "checkOrder.serviceOrder": "Service order",
  "checkOrder.productsOrdered": "Products ordered",
  "checkOrder.orderInfos": "Order info",
  "checkOrder.orderInfo": "Order info",
  "checkOrder.attachments": "Attachments",
  "checkOrder.detailsExpress": "Details",
  "checkOrder.sceneFiles": "Scene files",
  "checkOrder.spaceProductName": "Space product name",
  "checkOrder.afterSalesOrder": "After-sales order",
  "checkOrder.productChannels": "Product channels",
  "checkOrder.standardProducts": "Standard  products",
  "checkOrder.placeAnOrder": "Place an order",
  "checkOrder.doNotPlaceAnOrder": "Do not place orders",
  "checkOrder.design": "Design",
  "checkOrder.specs": "Specs",
  "checkOrder.model": "Model",
  "checkOrder.code": "Code",
  "checkOrder.productType": "Product type",
  "checkOrder.details": "Details",
  "checkOrder.addStandardProducts": "Add standard products",
  "checkOrder.serviceOrderNumber": "Service order number",
  "checkOrder.noServiceOrderNumber": "No service order number",
  "checkOrder.orderName": "Order name",
  "checkOrder.orderConsistent": "Is the entire order consistent",
  "checkOrder.productCategory": "Product category",
  "checkOrder.designSource": "Design source",
  "checkOrder.approvalForm": "With approval form or not",
  "checkOrder.assembled": "Assembled or not",
  "checkOrder.markType": "Mark type",
  "checkOrder.assemblyMethod": "Product assembly method",
  "checkOrder.cartonRequirements": "Carton requirements",
  "checkOrder.logisticsMethods": "Logistics methods",
  "checkOrder.displayRequirements": "Sample display requirements",
  "checkOrder.installationMethod": "Installation method of basin",
  "checkOrder.customerSupplied": "Non-factory products need to be matched",
  "checkOrder.projectInfo": "Project info",
  "checkOrder.batchOrderQuantity": "Batch order quantity",
  "checkOrder.remarks": "Remarks",
  "checkOrder.variableTable": "Variable table",
  "checkOrder.view": "View",
  "checkOrder.setup": "Set up",
  "checkOrder.orderQuantity": "Order quantity",
  "checkOrder.orderableQuantity": "Orderable quantity",
  "checkOrder.ordersPlacedNunmber": "Number of orders placed this time",
  "checkOrder.upload": "Upload",
  "checkOrder.splittingOrders": "Instructions for splitting orders",
  "checkOrder.splitOrderSuccessful": "Split order Successful",
  "checkOrder.splitOrderFailed": "Split order failed",
  "checkOrder.initiateInspection": "Initiate inspection",
  "checkOrder.oneClickOrder": "One-click order",
  "checkOrder.refreshOrder": "Refresh order progress",
  "checkOrder.relatedOrderApplication": "Related order application",
  "checkOrder.buildingAbbreviation": "Building abbreviation",
  "checkOrder.orderApplicationNo": "Order application number",
  "checkOrder.numberOfSetsOrdered": "Number of sets ordered",
  "checkOrder.search": "Search",
  "checkOrder.addServiceOrder": "Add service order",
  "checkOrder.option": "Option",
  "checkOrder.houseType": "House type",
  "checkOrder.schemeNo": "Scheme No.",
  "checkOrder.orderQuantitys": "Order quantity",
  "checkOrder.engineerServiceOrder": "Service Order",
  "checkOrder.batchSettings": "Batch Settings",
  "checkOrder.brandCategory": "Brand category",
  "checkOrder.orderType": "Order type",
  "checkOrder.EngineeringServiceNumber": "Service order number",
  "checkOrder.splitOrderDetails": "Instructions for splitting orders",
  "checkOrder.initiateSplitOrder": "Initiate split order",
  "checkOrder.serialNumber": "Serial Number",
  "checkOrder.placeOrderOrNot": "Place an order or not",
  "checkOrder.customerName": "Customer Name",
  "checkOrder.customerPhone": "Customer phone",
  "checkOrder.customerAddress": "Customer address",
  "checkOrder.associateBefore":
    "Please associate the order application before placing the order",
  "checkOrder.selectSceneFirst": "Please select a scene file first",
  "checkOrder.faucetCode": "Faucet Code",
  "checkOrder.deliveryTomorrow":
    "The expected delivery date needs to be selected after tomorrow",
  "checkOrder.basinInstallation":
    "The installation method of the water basin cannot be empty",
  "checkOrder.assembleEmpty": "Whether to assemble can not be empty",
  "checkOrder.quantityEmpty": "The quantity of the batch order cannot be empty",
  "checkOrder.nonStandardApproval": "Please select non-standard approval form",
  "checkOrder.serviceOrderIdEmpty":
    "Service order id cannot be empty, please select another service order",
  "checkOrder.quantityOrderEmpty": "The quantity of this order cannot be 0",
  "checkOrder.brandCategoryConsistent":
    "The brand and category of the combined cabinet must be consistent with the service order",
  "checkOrder.contractNumberInvalid":
    "The selected service order contract number is invalid, please replace the service order",
  "checkOrder.requiresSettingVariables":
    "Non whole order consistency requires setting variables",

  "checkOrder.sourceEmpty": "The design source cannot be empty",
  "checkOrder.variableEmpty":
    "The variable has not been set and needs to be associated with a consistent service order for the entire order. Please check if the variable or service order is correct",
  "checkOrder.variableNotEmpty":
    "The variable has been set and needs to be associated with a service order that is not consistent with the entire order. Please check if the variable or service order is correct",
  "checkOrder.categoryEmpty": "The product category cannot be empty",
  "checkOrder.expectedDeliveryEmpty":
    "The expected delivery date cannot be empty",
  "checkOrder.spaceProductsEmpty": "Space products cannot be empty",
  "checkOrder.associatedOrderEmpty":
    "The associated project service order cannot be empty.",
  "checkOrder.markTypeEmpty": "The mark type cannot be empty",
  "checkOrder.assemblyEmpty": "The product assembly method cannot be empty",
  "checkOrder.cartonEmpty": "The requirements of the carton cannot be empty",
  "checkOrder.LogisticsProcessEmpty": "Logistics process can not be empty",
  "checkOrder.sampleDisplayEmpty":
    "The Sample display requirements cannot be empty.",
  "checkOrder.customerSuppliesEmpty": "Customer supplies can not be empty",
  "checkOrder.selectedItemN":
    "The order quantity cannot be 0, please  set whether to place an order in the variable setting",
  "checkOrder.pleaseCheck": "Please check the order details",
  "checkOrder.orderIsRepeated":
    "The associated project service order is repeated, please modify the associated project service order to place an order!",
  "checkOrder.contractSelfNumber":
    "The contract self-number of the associated engineering service order is repeated, please revise it and place an order again.",
  "checkOrder.sceneContentChanged":
    "Scene content has changed, please confirm the order information",
  "checkOrder.retailOrdersSinks":
    "Retail orders for sinks cannot be placed with a single basin, please choose sets of basins to place orders",
  "checkOrder.attachmentsModified":
    "Attachments cannot be modified after placing an order.",
  "checkOrder.splitOrderNotCompleted":
    "Split order not completed, unable to continue placing order",
  "checkOrder.newInspection":
    "Please initiate a new inspection and order splitting!",
  "checkOrder.caxaCounterTop":
    "Please fill in the reason for not using CAXA countertop drawings",
  "checkOrder.illegalCharacters1":
    "The file name of the uploaded attachment contains illegal characters.",
  "checkOrder.illegalCharacters2":
    "Please correct the file name and upload again",
  "checkOrder.notAllowXml":
    "One-click order does not allow users to upload xml files",
  "checkOrder.notAllowCountertop":
    'The name of the currently uploaded file contains the word "countertop". If you want to upload a countertop file, please choose the "countertop attachment" type to upload (the bathroom countertop image is generated through CAXA and self uploading is not allowed)',
  "checkOrder.notCloseDesignFile":
    "The design software is in the process of splitting the order. Please do not close the design file. Please wait,Already used  ",
  "checkOrder.individualStandard":
    "Individual standard product orders do not need to split orders, can be placed directly",
  "checkOrder.successfullySubmitted":
    "Successfully submitted the split order, you can stay on the current page to refresh the progress of the split order, or close the current page to view the progress in the order task",
  "checkOrder.taskAlreadyHas":
    "The current order task already has a split order task. This operation will generate a new order task. Please confirm whether to continue",
  "checkOrder.orderNotDetected":
    "The project service order has not detected the relevant contract self-number, please re-select a valid project service order",
  "checkOrder.sceneNotVariables":
    "Scene file does not set variables, or abnormal data return please check! ",
  "checkOrder.serviceOrderAgain1":
    "The service order cannot be placed because the contract number of the after-sales order is not found. Please select the service order again.",
  "checkOrder.serviceOrderAgain2":
    "The service order cannot be placed because the contract number of the order is not found. Please select the service order again.",
  "checkOrder.canBePlaced":
    'Service order can only be placed under the status of "No order "," Successful order "," failed order "," Design document processing "," Design document processing succeeded "," Design document processing failed"',
  "checkOrder.readingScene": "Reading scene file content",
  "checkOrder.batchDownload": "Batch download of split order files",
  "checkOrder.hasBeenSubmitted":
    "The order task has been submitted. Please refer to 'My Order Tasks' for specific order results.",
  "checkOrder.selectedItem": "Selected item ",
  "checkOrder.and": "and",
  "checkOrder.name": "Name",
  "checkOrder.accountNumber": "Account number",
  "checkOrder.orderApplications": "Please select an order application",
  "checkOrder.applicationInvalid":
    "The selected order application is invalid/does not have a service order number",
  "checkOrder.applicationRelated":
    "Complete the application for placing an order related to the project application for placing an order",
  "checkOrder.non-standardMaterials":
    "When approving non-standard materials, please select non-standard materials for the product category",
  "checkOrder.countertopAttachment":
    'Note: If you need to upload tabletop related attachments, please choose the "Countertop Attachment" type to upload',
  "checkOrder.notAllowedCad":
    "Starting from July 10th, CAD orders are not allowed for cabinet project countertops. If you have any questions, please consult the Q&A platform",
  "checkOrder.enterContractNumber": "Please enter the contract self number",
  "checkOrder.variableSettings": "Variable settings",
  "checkOrder.importVariable": "Import Variable Table",
  "checkOrder.exportVariable": "Export Variable Table",
  "checkOrder.orderOrNot": "Place an order or not",
  "checkOrder.clearVariable": "Clear the current variable value",
  "checkOrder.reuseVariable": "Reuse historical variable values",
  "checkOrder.viewingVariable": "Viewing Historical Variable Values",
  "checkOrder.resetVariable": "Please reset the variables",
  "checkOrder.displayOrderInformation":
    "Display order information after associated order application",
  "checkOrder.pleaseSelect": "Please select",
  "checkOrder.personnelList": "Personnel List",
  "checkOrder.nameJobMobile": "Name/Job ID/Mobile Number",
  "checkOrder.option": "option",
  "checkOrder.departmentStore": "Department/Store",
  "checkOrder.post": "post",
  "checkOrder.resignationOrNot": "Resignation or not",
  "checkOrder.total": "Total",
  "checkOrder.page": "page",
  "checkOrder.goTo": "go to",
  "checkOrder.confirm": "confirm",
  "checkOrder.searchContract":
    "Search for contract self number and order number",
  "checkOrder.batchOrderPlacement": "Batch order placement",
  "checkOrder.numberOfSets": "Number of sets",
  "checkOrder.projectBatchInformation": "Project batch information",
  "checkOrder.factoryPlanned": "Factory Planned Delivery Date",
  "checkOrder.administrativeDivision": "administrative division",
  "checkOrder.placeOrderNot": "place order or not",
  "checkOrder.FlyerTime": "Flyer time",
  "checkOrder.specificAddress": "Specific address",
  "checkOrder.otherAttachments": "Other attachments",
  "checkOrder.counterTopAttachments": "Countertop attachments",
  "checkOrder.priceAttachments": "Price attachments",
  "checkOrder.uploadAttachments": "Upload attachments",
  "checkOrder.counterTop": "Countertop",
  "checkOrder.selectAll": "Select all",
  "checkOrder.startDate": "Start date",
  "checkOrder.endDate": "End date",
  "checkOrder.to": "to",
  "checkOrder.selectBrand": "Please select brand",
  "checkOrder.selectCategory": "Please select category",
  "checkOrder.transferred": "Transferred to",
  "checkOrder.clickTransferred": "Click to transfer to",
  "checkOrder.oderUpdateTime": "Order update time",
  "checkOrder.noDataAvailable": "There is currently no data available",
  "checkOrder.loadingDesperately": "Loading desperately",
  "checkOrder.orderUpdateTime":
    "Please confirm that the selected order is the latest order information based on the order update time",
  "checkOrder.successfullyPlaced": "Successfully placed an order",
  "checkOrder.defaultOrderType":
    "PTD-WMD-10-30-Foreign trade orders-Ordinary orders",
  "checkOrder.enter": "Enter",
  "checkOrder.designerPhoneEmpty": "Designer phone cannot be empty",
  "checkOrder.designerEmpty": "Designer cannot be empty",
  "checkOrder.selectDate": "Select Date",
  "checkOrder.modifyingSpace":
    "After modifying the space product name, the existing order cannot be overwritten. Please confirm if the order has been uploaded to avoid duplicate orders",
  "checkOrder.coverTabletop":
    "The tabletop drawings uploaded this time will cover the tabletop drawings in the attachment of the design software disassembly order. Please confirm whether to replace them?",

  "checkOrder.oppein": "OPPEIN",
  "checkOrder.outu": "Outu",
  "checkOrder.oboli": "OPPLIA",
  "checkOrder.oboni": "OPLONI",
  "checkOrder.owell": "OWELL",
  "checkOrder.baunis": "Baunis",
  "checkOrder.starhomes": "STARHOMES",
  "checkOrder.oboladi": "Oboladi",
  "checkOrder.fitzcarl": "Fitzcarl",
  "checkOrder.baunisStarhomes": "Baunis",
  "checkOrder.miform": "Miform",

  "checkOrder.youcai": "Excellent materials",
  "checkOrder.zhuangxiu": "Decoration materials",
  "checkOrder.zhucaijicheng": "Main material integration",
  "checkOrder.zhuangjiamen": "Armored door",
  "checkOrder.bancai": "Board",
  "checkOrder.shangchu": "Commercial cabinet",
  "checkOrder.jinshumenchuang": "Metal doors and windows",
  "checkOrder.dajiaju": "Whole house",
  "checkOrder.qiangshi": "Soft decoration",
  "checkOrder.mumen": "Wooden door",
  "checkOrder.zhinengjiaju": "Smart home",
  "checkOrder.weiyu": "Vanity",

  "checkOrder.wardrobe": "Wardrobe",
  "checkOrder.cabinet": "Cabinet",
  "checkOrder.queuing": "queuing",
  "checkOrder.splittingOrders": "In the process of splitting orders",
  "checkOrder.successfullySplit": "Successfully split the order",
  "checkOrder.splitOrderFailed": "Split order failed",
  "checkOrder.cancelSplit": "Cancel split order",
  "checkOrder.simpleOrder": "Simple order splitting",
  "checkOrder.fullOrder": "Full order splitting",
  "checkOrder.taskStatus": "Please select the task status",
  "checkOrder.taskType": "Please select a task type",
  "checkOrder.splitRecord":
    "Please select the split record that needs to be exported!",
  "checkOrder.splitNoFiles":
    "No files have been successfully split, please confirm!",
  "checkOrder.cancelSplitSuccess": "Successfully cancelled the split order",
  "checkOrder.selectPersonnel": "Please select personnel",
  "checkOrder.notCreated": "Not created",
  "checkOrder.creating": "Creating",
  "checkOrder.createdSuccessfully": "Created successfully",
  "checkOrder.creationFailed": "Creation failed",
  "checkOrder.designFileProcessing": "Design file processing",
  "checkOrder.successfullyDesignFiles": "Successfully processed design files",
  "checkOrder.designFileFailed": "Design file processing failed",
  "checkOrder.draftSaved": "Draft saved",
  "checkOrder.readingScheme": "Reading scheme content",
  "checkOrder.uploadSuccessful": "Upload successful",
  "checkOrder.batchSetBrand":
    "Batch set product categories for the same brand category",
  "checkOrder.enoppein": "OPPEIN",
  "checkOrder.importCompleted": "Import completed",
  "checkOrder.exporting": "Exporting, please wait...",
  "checkOrder.deleteTask":
    "Are you sure to delete the order task? The task record is not visible after deletion",
  "checkOrder.successfullyDeleted": "Successfully deleted",
  "checkOrder.confirmation": "Confirmation",
  "checkOrder.useCaxaTabletop":
    "Please choose the reason not to use CAXA tabletop diagram",
  "checkOrder.successfullyDeleted": "Successfully deleted",
  "checkOrder.deleteOrder": "Are you sure to delete the order ?",
};



// WEBPACK FOOTER //
// ./src/locales/lang/en-US/check/settings.js